// src/admin/pages/AdminCategories.js
import React, { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaPlus, FaTrash, FaSearch } from "react-icons/fa";
import { FaTags } from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminCategoriesWithProducts,
  createAdminCategory,
  deleteAdminCategory,
  updateAdminCategory,
  getAdminCategoryProducts,
  removeAdminProductFromCategory,
} from "../../services/adminProducts.api";
import { getAdminProducts, addProductsToCategory } from "../../services/adminProducts.api";

function AdminCategories() {
  const navigate = useNavigate();
  const { lang } = useContext(AdminLanguageContext);
  const [isOpen, setIsOpen] = useState(false);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editingCategory, setEditingCategory] = useState(null);
  const [editValues, setEditValues] = useState({
  name_en: "",
  name_ar: "",
  menu_group: "none",
});

const [productsModal, setProductsModal] = useState(null);
const [productsModalItems, setProductsModalItems] = useState([]);
const [productsModalPage, setProductsModalPage] = useState(1);
const [productsModalTotal, setProductsModalTotal] = useState(0);
const [productsModalTotalPages, setProductsModalTotalPages] = useState(1);
const [productsModalLimit] = useState(8);
const [productsModalLoading, setProductsModalLoading] = useState(false);
const [productsModalRemovingId, setProductsModalRemovingId] = useState(null);

const [showAddProductsModal, setShowAddProductsModal] = useState(false);
const [allProducts, setAllProducts] = useState([]);
const [productsSearch, setProductsSearch] = useState("");
const [selectedProductsMap, setSelectedProductsMap] = useState({});
const [productsModalPage2, setProductsModalPage2] = useState(1);
const PRODUCTS_MODAL_LIMIT = 5;
const [loadingProductsList, setLoadingProductsList] = useState(false);

  const [lastDeleted, setLastDeleted] = useState(null);

  const [searchOpen, setSearchOpen] = useState(false);

  const [slug, setSlug] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [menuGroup, setMenuGroup] = useState("none");
  
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [showAdd, setShowAdd] = useState(false);
  const [search, setSearch] = useState("");

  const [confirmAction, setConfirmAction] = useState(null);
  const [toast, setToast] = useState("");

  
  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
  const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
  const isAdmin = adminUser.role === "admin";
  const canAccess = isAdmin || perms.can_manage_products;

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const MENU_GROUP_OPTIONS = [
  { value: "none", labelEN: "None", labelAR: "بدون" },
  { value: "clothes", labelEN: "Clothes", labelAR: "ملابس" },
  { value: "shoes", labelEN: "Shoes", labelAR: "أحذية" },
  { value: "accessories", labelEN: "Accessories", labelAR: "إكسسوارات" },
];

  useEffect(() => {
  const handleEscape = (e) => {
    if (e.key === "Escape") {
      closeProductsModal();
    }
  };

  if (productsModal || showAddProductsModal) {
    document.addEventListener("keydown", handleEscape);
  }

  return () => {
    document.removeEventListener("keydown", handleEscape);
  };
}, [productsModal, showAddProductsModal]);

  useEffect(() => {
    if (!canAccess) return;
    load();
  }, [canAccess]);

  const load = async () => {
    setLoading(true);
    const data = await getAdminCategoriesWithProducts();
    setCategories(data);
    setLoading(false);
  };

  const toggleCategorySelection = (id) => {
  setSelectedCategories((prev) =>
    prev.includes(id)
      ? prev.filter((c) => c !== id)
      : [...prev, id]
  );
};

const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;

  const base =
    process.env.REACT_APP_API_URL?.replace(/\/api$/, "") ||
    window.location.origin;

  return base + url;
};

const fetchProductsModalPage = async (categoryId, page = 1) => {
  setProductsModalLoading(true);

  try {
    const res = await getAdminCategoryProducts(categoryId, page, productsModalLimit);

    const items = res.items || [];
    const total = Number(res.pagination?.total || 0);
    const limit = Number(res.pagination?.limit || productsModalLimit);
    const totalPages = Math.max(1, Math.ceil(total / limit));

    setProductsModalItems(items);
    setProductsModalPage(page);
    setProductsModalTotal(total);
    setProductsModalTotalPages(totalPages);
  } finally {
    setProductsModalLoading(false);
  }
};

const openProductsModal = async (category) => {
  setProductsModal(category);
  setProductsModalItems([]);
  setProductsModalPage(1);
  setProductsModalTotal(0);
  setProductsModalTotalPages(1);

  await fetchProductsModalPage(category.id, 1);
};

const handleRemoveProductFromCategory = async (productId) => {
  if (!productsModal) return;

  setProductsModalRemovingId(productId);

  try {
    await removeAdminProductFromCategory(productsModal.id, productId);

    const nextTotal = Math.max(0, productsModalTotal - 1);
    const nextTotalPages = Math.max(1, Math.ceil(nextTotal / productsModalLimit));
    const nextPage =
      productsModalPage > nextTotalPages ? nextTotalPages : productsModalPage;

    setProductsModal((prev) =>
      prev
        ? {
            ...prev,
            products_count: Math.max(0, Number(prev.products_count || 0) - 1),
          }
        : prev
    );

    setCategories((prev) =>
      prev.map((cat) =>
        cat.id === productsModal.id
          ? {
              ...cat,
              products_count: Math.max(0, Number(cat.products_count || 0) - 1),
              products: (cat.products || []).filter((p) => p.id !== productId),
            }
          : cat
      )
    );

    await fetchProductsModalPage(productsModal.id, nextPage);

    setToastMessage(
      lang === "AR"
        ? "تم إزالة المنتج من التصنيف"
        : "Product removed from collection"
    );
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  } finally {
    setProductsModalRemovingId(null);
  }
};

const toggleSelectAll = () => {
  if (selectedCategories.length === filtered.length) {
    setSelectedCategories([]);
  } else {
    setSelectedCategories(filtered.map((c) => c.id));
  }
};

const handleInlineSave = async (category) => {
  await updateAdminCategory(category.id, {
  name_en: editValues.name_en,
  name_ar: editValues.name_ar,
  menu_group: editValues.menu_group,
});

  setEditingCategory(null);

  setToastMessage(
    lang === "AR"
      ? "تم تحديث التصنيف"
      : "Collection updated"
  );
  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);

  load();
};

const confirmBulkDelete = () => {
  setConfirmAction({
    type: "bulk",
    message:
      lang === "AR"
        ? "سيتم حذف عدة تصنيفات. لا يمكن التراجع."
        : "You are about to delete multiple categories.",
  });
};

const handleBulkDelete = async () => {
  await Promise.all(
    selectedCategories.map((id) => deleteAdminCategory(id))
  );

  setSelectedCategories([]);
  setConfirmAction(null);

  setToastMessage(
    lang === "AR"
      ? "تم حذف التصنيفات"
      : "Categories deleted"
  );
  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);

  load();
};

  const filtered = useMemo(() => {
  return categories
    .filter((c) => {
      const text = (c.name_en + c.name_ar + c.slug).toLowerCase();
      return text.includes(search.toLowerCase());
    })
    .sort((a, b) =>
      a.name_en.localeCompare(b.name_en, "en", { sensitivity: "base" })
    );
}, [categories, search]);

const filteredProductsModal = useMemo(() => {
  const q = productsSearch.toLowerCase();

  return allProducts.filter(p =>
    (p.name_en + p.public_id)
      .toLowerCase()
      .includes(q)
  );
}, [allProducts, productsSearch]);

const paginatedProducts = useMemo(() => {
  const start = (productsModalPage2 - 1) * PRODUCTS_MODAL_LIMIT;
  return filteredProductsModal.slice(start, start + PRODUCTS_MODAL_LIMIT);
}, [filteredProductsModal, productsModalPage2]);

  const handleCreate = async () => {
    if (!slug || !nameEn) return;

    if (editingCategory) {
  await updateAdminCategory(editingCategory, {
  slug: slug.trim(),
  name_en: nameEn.trim(),
  name_ar: nameAr.trim(),
  menu_group: menuGroup,
});
  setEditingCategory(null);
} else {
  await createAdminCategory({
  slug: slug.trim(),
  name_en: nameEn.trim(),
  name_ar: nameAr.trim(),
  menu_group: menuGroup,
});
}

    setSlug("");
    setNameEn("");
    setNameAr("");
    setMenuGroup("none");
    setShowAdd(false);

    setToastMessage(
  lang === "AR"
    ? "تم إنشاء التصنيف بنجاح"
    : "Collection created successfully"
);
setShowToast(true);
setTimeout(() => setShowToast(false), 3000);
    load();
  };

  const confirmDelete = (category) => {
  const hasProducts = category.products?.length > 0;

  setConfirmAction({
    type: "single",
    id: category.id,
    message: hasProducts
      ? lang === "AR"
        ? "هذا التصنيف يحتوي على منتجات. سيتم فك الربط منها. هل أنت متأكد؟"
        : "This category has products. They will be unlinked. Are you sure?"
      : lang === "AR"
      ? "هل تريد حذف هذا التصنيف؟"
      : "Delete this category?",
  });
};

  const handleDelete = async () => {
  const deletedItem = categories.find(c => c.id === confirmAction.id);

  await deleteAdminCategory(confirmAction.id);

  setLastDeleted(deletedItem); // ✅ store for undo
  setConfirmAction(null);

  setToastMessage(
    <div className="flex items-center gap-3">
      <span>
        {lang === "AR"
          ? "تم حذف التصنيف"
          : "Collection deleted"}
      </span>

      <button
        onClick={handleUndoDelete}
        className="underline text-black font-medium"
      >
        {lang === "AR" ? "تراجع" : "Undo"}
      </button>
    </div>
  );

  setShowToast(true);
  setTimeout(() => setShowToast(false), 5000);

  load();
};

const handleUndoDelete = async () => {
  if (!lastDeleted) return;

  await createAdminCategory({
    slug: lastDeleted.slug,
    name_en: lastDeleted.name_en,
    name_ar: lastDeleted.name_ar,
  });

  setLastDeleted(null);

  setToastMessage(
    lang === "AR"
      ? "تم استرجاع التصنيف"
      : "Category restored"
  );

  setShowToast(true);
  setTimeout(() => setShowToast(false), 3000);

  load();
};

const closeProductsModal = () => {
  setProductsModal(null);
  setProductsModalItems([]);
  setProductsModalPage(1);
  setProductsModalTotal(0);
  setProductsModalTotalPages(1);

  setShowAddProductsModal(false);
  setProductsSearch("");
  setProductsModalPage2(1);
  setSelectedProductsMap({});
};

  return (
    <div className={`flex bg-[#f6f6f7] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""}`}>
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-3 sm:p-4 max-w-[1200px] mx-auto space-y-4">

          {!canAccess ? (
            <div className="bg-white border border-red-200 rounded-xl p-6 text-center">
              <p className="text-red-700 text-sm">
                {lang === "AR" ? "غير مصرح" : "Not allowed"}
              </p>
            </div>
          ) : (
            <>
              {/* 🔥 HEADER (SHOPIFY STYLE) */}
              <div className="flex items-center justify-between">

                {/* LEFT */}
               <div className="flex items-center gap-2">
  <div className="flex items-center justify-center w-6 h-6">
    <FaTags className="text-gray-900 text-[16px] rotate-180" />
  </div>

  <h1 className="text-[20px] font-semibold text-gray-900">
    {lang === "AR" ? "المجموعات" : "Collections"}
  </h1>
</div>

                {/* RIGHT */}
                <div className="flex items-center gap-2">

  {/* ADD BUTTON */}
  <button
    onClick={() => setShowAdd(true)}
    className="
    h-8 px-3
    bg-[#1f1f1f] text-white
    rounded-lg text-sm font-medium
    hover:bg-black
    flex items-center gap-2
    "
  >
    {lang === "AR" ? "إضافة مجموعة" : "Add collection"}
  </button>

</div>
              </div>

              {/* ➕ ADD MODAL */}
              {showAdd && (
  <div className="
  fixed inset-0 z-50 bg-black/40
  flex items-end md:items-center justify-center
">

    <div className="
  w-full
  max-w-lg
  h-[40vh]
  md:h-auto
  bg-white
  rounded-t-2xl md:rounded-2xl
  flex flex-col
">

      {/* HEADER */}
      <div className="px-5 py-4 border-b flex justify-between items-center">
        <h2 className="text-lg font-semibold text-gray-900">
          {lang === "AR" ? "إضافة تصنيف" : "Add collection"}
        </h2>

        <button
          onClick={() => setShowAdd(false)}
          className="text-gray-400 hover:text-gray-900 text-xl"
        >
          ✕
        </button>
      </div>

      {/* BODY */}
      <div className="p-4 space-y-3 flex-1 overflow-y-auto">

        <div>
          <label className="text-sm font-medium text-gray-900">{lang === "AR" ? "المعرف (Slug)" : "Slug"}</label>
          <input
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            className="mt-1 w-full px-3 py-2 border rounded-md text-sm"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-900">{lang === "AR" ? " الاسم (EN) " : "Name (EN)"}</label>
          <input
            value={nameEn}
            onChange={(e) => setNameEn(e.target.value)}
            className="mt-1 w-full px-3 py-2 border rounded-md text-sm"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-900">{lang === "AR" ? " الاسم (AR) " : "Name (AR)"}</label>
          <input
            value={nameAr}
            onChange={(e) => setNameAr(e.target.value)}
            className="mt-1 w-full px-3 py-2 border rounded-md text-sm"
          />
        </div>
<div>
  <label className="text-sm font-medium text-gray-900">
    {lang === "AR" ? "مجموعة القائمة" : "Menu group"}
  </label>

  <select
    value={menuGroup}
    onChange={(e) => setMenuGroup(e.target.value)}
    className="mt-1 w-full px-3 py-2 border rounded-md text-sm bg-white"
  >
    {MENU_GROUP_OPTIONS.map((option) => (
      <option key={option.value} value={option.value}>
        {lang === "AR" ? option.labelAR : option.labelEN}
      </option>
    ))}
  </select>
</div>
      </div>

      {/* FOOTER */}
     <div className="
  px-5 py-4 border-t bg-white rounded-b-2xl
">
  <div className="flex justify-end gap-2 max-w-md ml-auto">

        <button
          onClick={() => setShowAdd(false)}
          className="px-4 py-2 border rounded-md text-sm"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={handleCreate}
          className="px-4 py-2 bg-black text-white rounded-md text-sm"
        >
          {lang === "AR" ? "حفظ" : "Save"}
        </button>

      </div>
</div>
    </div>
  </div>
)}

              {/* 📊 TABLE */}
              <div className="
bg-white
border border-[#e3e3e3]
rounded-[14px]
overflow-hidden
shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]
">

{/* 🔥 TOP HEADER (LIKE PRODUCTS PAGE) */}
<div className="flex items-center justify-between px-4 py-2 border-b bg-white">

  {/* LEFT SIDE */}
{!searchOpen ? (

  <div></div> // keep empty like products (no filters)

) : (

  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full">

    <div className="
      flex items-center justify-between
      flex-1
      h-8
      px-3
      bg-white
      border border-gray-300
      rounded-lg
      shadow-sm
      focus-within:border-gray-500
      focus-within:ring-2
      focus-within:ring-gray-200
      transition
    ">

      <div className="flex items-center gap-2 flex-1">
        <FaSearch className="text-gray-400 text-sm" />
        <input
          autoFocus
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={lang === "AR" ? "بحث..." : "Search..."}
          className="flex-1 outline-none text-sm"
        />
      </div>

      {/* 🔥 CLOSE ICON (LIKE PRODUCTS) */}
      <button
        onClick={() => {
          setSearch("");
          setSearchOpen(false);
        }}
        className="w-5 h-5 flex items-center justify-center rounded-full border border-gray-500 text-gray-500 hover:bg-gray-100"
      >
        ✕
      </button>

    </div>

    {/* 🔥 CANCEL BUTTON */}
    <button
      onClick={() => {
        setSearch("");
        setSearchOpen(false);
      }}
      className="px-3 h-8 bg-white border border-gray-300 rounded-lg shadow-sm text-sm font-medium"
    >
      {lang === "AR" ? "إلغاء" : "Cancel"}
    </button>

  </div>

)}

  {/* RIGHT */}
  <div className="flex items-center gap-2">

    {/* BULK DELETE */}
    {selectedCategories.length > 0 && (
      <button
        onClick={confirmBulkDelete}
        className="
        flex items-center justify-center
        w-9 h-9
        bg-white
        border border-gray-300
        rounded-lg
        shadow-sm
        hover:bg-gray-50
        "
      >
        <FaTrash className="text-gray-600 text-sm" />
      </button>
    )}

    {/* SEARCH BUTTON */}
    {!searchOpen && (
  <button
    onClick={() => setSearchOpen(true)}
    className="
    flex items-center justify-center gap-1
    px-2 h-9
    bg-white
    border border-gray-300
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.05),0_2px_4px_rgba(0,0,0,0.06)]
    hover:bg-gray-50
    active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.08)]
    transition
    "
  >
    <FaSearch className="text-gray-600 text-sm" />
    <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
      <path
        d="M3 5H17M6 10H14M9 15H11"
        stroke="#4B5563"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </button>
)}

  </div>
</div>
{/* 📱 MOBILE CARDS */}
<div className="md:hidden space-y-3 px-2 pb-3">

{loading ? (
  [...Array(4)].map((_, i) => (
    <div key={i} className="bg-white rounded-xl p-4 animate-pulse">
      <div className="h-4 w-32 bg-gray-200 rounded mb-2" />
      <div className="h-3 w-20 bg-gray-100 rounded mb-2" />
      <div className="h-3 w-16 bg-gray-200 rounded" />
    </div>
  ))
) : filtered.length === 0 ? (

  <div className="text-center py-10">
    <div className="text-sm text-gray-600">
      {lang === "AR" ? "لا توجد مجموعات" : "No collections"}
    </div>
  </div>

) : (

  filtered.map((c) => (
    <div
  key={c.id}
  className="bg-white rounded-xl border border-gray-200 p-3 space-y-3"
>

  {/* TOP ROW */}
  <div className="flex items-center justify-between">

    {/* NAME */}
    <div className="min-w-0">
      <div className="text-sm font-semibold text-gray-900 truncate">
        {c.name_en}
      </div>
      <div className="text-xs text-gray-400 truncate">
        {c.name_ar}
      </div>
    </div>

    {/* ACTIONS */}
    <div className="flex items-center gap-2">

      {/* EDIT */}
      <button
  onClick={() => {
    setShowAdd(true);
setSlug(c.slug);
setNameEn(c.name_en);
setNameAr(c.name_ar);
setMenuGroup(c.menu_group || "none");
setEditingCategory(c.id);
  }}
        className="text-xs px-2 py-1 border rounded-md bg-white hover:bg-gray-50"
      >
        {lang === "AR" ? "تعديل" : "Edit"}
      </button>

      {/* DELETE */}
      <button
        onClick={() => confirmDelete(c)}
        className="text-gray-400 hover:text-red-600"
      >
        <FaTrash />
      </button>

    </div>
  </div>

  {/* SLUG */}
  <div className="text-[11px] text-gray-500 break-all">
    {c.slug}
  </div>

  {/* PRODUCTS */}
  <div
    onClick={() => openProductsModal(c)}
    className="
  flex items-center justify-between
  text-xs
  text-gray-900
  bg-gray-50
  px-3 py-2
  rounded-md
  cursor-pointer
  hover:bg-gray-100
  active:scale-[0.98]
  transition
"
  >
    <span>
      {lang === "AR" ? "المنتجات" : "Products"}
    </span>

    <span className="font-medium">
      {c.products_count}
    </span>
  </div>

</div>
  ))

)}

</div>

                <table className="hidden md:table w-full text-[13px]">
                  <thead className="bg-gray-50 text-xs text-gray-600 border-b">
                    <tr>
                      <th className="w-[40px] px-3 py-2 text-center">
  <input
    type="checkbox"
    checked={
      selectedCategories.length === filtered.length &&
      filtered.length > 0
    }
    onChange={toggleSelectAll}
    className="w-4 h-4 accent-gray-800"
  />
</th>
                      <th className="px-4 py-2 text-left">
                        {lang === "AR" ? "الاسم" : "Name"}
                      </th>
                      <th className="px-4 py-2 text-left">{lang === "AR" ? "المعرف (Slug)" : "Slug"}</th>
                      <th className="px-4 py-2 text-left">
                        {lang === "AR" ? "منتجات" : "Products"}
                      </th>
                      <th className="px-4 py-2 text-right"></th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
  [...Array(6)].map((_, i) => (
    <tr key={i} className="border-b">
      {/* CHECKBOX */}
      <td className="px-3 py-2 text-center">
        <div className="w-4 h-4 bg-gray-200 rounded animate-pulse mx-auto" />
      </td>

      {/* NAME */}
      <td className="px-4 py-2">
        <div className="h-3 w-32 bg-gray-200 rounded animate-pulse mb-1" />
        <div className="h-2 w-24 bg-gray-100 rounded animate-pulse" />
      </td>

      {/* SLUG */}
      <td className="px-4 py-2">
        <div className="h-3 w-24 bg-gray-200 rounded animate-pulse" />
      </td>

      {/* PRODUCTS */}
      <td className="px-4 py-2">
        <div className="h-3 w-10 bg-gray-200 rounded animate-pulse" />
      </td>

      {/* ACTION */}
      <td className="px-4 py-2 text-right">
        <div className="h-4 w-4 bg-gray-200 rounded animate-pulse ml-auto" />
      </td>
    </tr>
  ))
) : (
                      filtered.length === 0 ? (
  <tr>
    <td colSpan="5" className="px-4 py-16 text-center">

      <div className="flex flex-col items-center gap-3">

        {/* ICON */}
        <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
         <div className="relative w-[20px] h-[20px]">
  <FaTags className="text-gray-900 text-[16px] rotate-180" /></div>
        </div>

        {/* TITLE */}
        <div className="text-sm font-medium text-gray-900">
          {lang === "AR"
            ? "لا توجد تصنيفات"
            : "No collections yet"}
        </div>

        {/* SUBTEXT */}
        <div className="text-xs text-gray-500">
          {lang === "AR"
            ? "ابدأ بإضافة أول تصنيف لتنظيم المنتجات"
            : "Start by creating your first collection"}
        </div>

        {/* CTA */}
        <button
          onClick={() => setShowAdd(true)}
          className="
          mt-2 px-4 py-2
          bg-black text-white
          rounded-md text-sm
          hover:bg-gray-800
          "
        >
          {lang === "AR" ? "إضافة تصنيف" : "Add collection"}
        </button>

      </div>

    </td>
  </tr>
) : (
                      filtered.map((c) => (
                        <tr key={c.id} className="border-b hover:bg-gray-50">
                          <td className="w-[40px] px-3 py-2 text-center align-middle">
  <input
    type="checkbox"
    checked={selectedCategories.includes(c.id)}
    onChange={() => toggleCategorySelection(c.id)}
    className="w-4 h-4 accent-gray-800 cursor-pointer align-middle"
  />
</td>
                         <td className="px-4 py-2 font-medium">

  {editingCategory === c.id ? (
    <div className="flex flex-col gap-2">

      {/* EN */}
<input
  value={editValues.name_en}
  onChange={(e) =>
    setEditValues((prev) => ({
      ...prev,
      name_en: e.target.value,
    }))
  }
  placeholder="Name (EN)"
  className="w-full px-2 py-1 border rounded-md text-sm"
/>

{/* AR */}
<input
  value={editValues.name_ar}
  onChange={(e) =>
    setEditValues((prev) => ({
      ...prev,
      name_ar: e.target.value,
    }))
  }
  placeholder="Name (AR)"
  className="w-full px-2 py-1 border rounded-md text-sm"
/>

{/* MENU GROUP */}
<select
  value={editValues.menu_group}
  onChange={(e) =>
    setEditValues((prev) => ({
      ...prev,
      menu_group: e.target.value,
    }))
  }
  className="w-full px-2 py-1 border rounded-md text-sm bg-white"
>
  {MENU_GROUP_OPTIONS.map((option) => (
    <option key={option.value} value={option.value}>
      {lang === "AR" ? option.labelAR : option.labelEN}
    </option>
  ))}
</select>

{/* ACTIONS */}
<div className="flex gap-2 mt-1">

        <button
          onClick={() => handleInlineSave(c)}
          className="px-2 py-1 bg-black text-white rounded text-xs"
        >
          {lang === "AR" ? "حفظ" : "Save"}
        </button>

        <button
          onClick={() => setEditingCategory(null)}
          className="px-2 py-1 border rounded text-xs"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

      </div>

    </div>
  ) : (
    <div
      onClick={() => {
        setEditingCategory(c.id);
        setEditValues({
  name_en: c.name_en,
  name_ar: c.name_ar,
  menu_group: c.menu_group || "none",
});
      }}
      className="cursor-pointer hover:underline"
    >
      <div>{c.name_en}</div>
      <div className="text-xs text-gray-400">{c.name_ar}</div>
    </div>
  )}

</td>

                          <td className="px-4 py-2 text-gray-500">
                            {c.slug}
                          </td>

                          <td
  className="px-4 py-2 text-gray-500 relative cursor-pointer"
  onClick={() => openProductsModal(c)}
>
  <span className="hover:underline">
    {c.products_count}
  </span>
</td>

                          <td className="px-4 py-2 text-right">
                            <button
                              onClick={() => confirmDelete(c)}
                              className="text-gray-400 hover:text-red-600"
                            >
                              <FaTrash />
                            </button>
                          </td>
                        </tr>
                      )))
                    )}
                  </tbody>

<tfoot>
<tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
<td colSpan="5" className="px-3 py-2 rounded-b-[14px]">

<div className="flex items-center justify-between text-sm text-gray-600">

  {/* COUNT */}
  <span className="text-gray-500">
    {filtered.length} {lang === "AR" ? "تصنيفات" : "categories"}
  </span>

  {/* PAGINATION (basic for now) */}
  <div className="flex items-center gap-2">
    <span className="text-gray-400 text-xs">
      {lang === "AR" ? "كل النتائج" : "All results"}
    </span>
  </div>

</div>

</td>
</tr>
</tfoot>

                </table>
              </div>
            </>
          )}
        </main>
      </div>

      {/* CONFIRM */}
      {confirmAction && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white rounded-xl p-5 w-full max-w-sm">
            <p className="mb-6 text-sm">{confirmAction.message}</p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setConfirmAction(null)}
                className="px-4 py-2 border rounded-md text-sm"
              >
                 {lang === "AR" ? "إلغاء" : "Cancel"}
              </button>

              <button
                onClick={
  confirmAction.type === "bulk"
    ? handleBulkDelete
    : handleDelete
}
                className="px-4 py-2 bg-black text-white rounded-md text-sm"
              >
                 {lang === "AR" ? "تأكيد" : "OK"}
              </button>
            </div>
          </div>
        </div>
      )}

{productsModal && (
  <div
  className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4"
  onClick={closeProductsModal}
>
    <div
  className="
  w-full
  max-w-2xl
  h-[40vh]
  md:h-auto
  flex flex-col
  bg-white
  rounded-2xl
  overflow-hidden
"
  onClick={(e) => e.stopPropagation()}
>
      
      {/* HEADER */}
      <div className="px-5 py-4 border-b flex justify-between items-center">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            {lang === "AR" ? "منتجات التصنيف" : "Category Products"}
          </h2>
          <p className="text-xs text-gray-500 mt-1">
  {lang === "AR"
    ? `${productsModal.name_ar || productsModal.name_en} (${productsModal.slug}) • ${productsModalTotal} منتج`
    : `${productsModal.name_en} (${productsModal.slug}) • ${productsModalTotal} products`}
</p>
        </div>

        <div className="flex items-center gap-2">

  {/* ➕ ADD PRODUCTS */}
  <div className="relative group">
    <button
  onClick={async () => {
    setShowAddProductsModal(true);
    setLoadingProductsList(true);

    try {
      const res = await getAdminProducts();
      setAllProducts(res || []);
      setProductsSearch("");
      setProductsModalPage2(1);

      const selected = {};
      (productsModal.products || []).forEach((p) => {
        selected[p.id] = true;
      });

      setSelectedProductsMap(selected);
    } finally {
      setLoadingProductsList(false);
    }
  }}
  className="
    h-8 px-3
    bg-[#1f1f1f] text-white
    rounded-lg text-sm font-medium
    hover:bg-black
    flex items-center gap-2
    transition
  "
>
  {productsModal.products_count > 0
    ? (lang === "AR" ? "تعديل" : "Edit")
    : (lang === "AR" ? "إضافة" : "Add")}
</button>

    {/* TOOLTIP */}
    <div className="absolute right-0 top-10 hidden group-hover:block bg-[#202223] text-white text-[11px] px-2.5 py-1.5 rounded-lg whitespace-nowrap shadow-lg">
  {productsModal.products_count > 0
    ? (lang === "AR" ? "تعديل منتجات التصنيف" : "Edit collection products")
    : (lang === "AR" ? "إضافة منتجات إلى التصنيف" : "Add products to this collection")}
</div>
  </div>

  

</div>
      </div>

      {/* CONTENT */}
      <div className="p-4 flex-1 overflow-y-auto space-y-2">
        {productsModalLoading && productsModalItems.length === 0 ? (
  [...Array(5)].map((_, i) => (
    <div
      key={i}
      className="flex items-center justify-between gap-3 border border-gray-200 rounded-lg px-3 py-2 animate-pulse"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-gray-200 rounded-md" />
        <div>
          <div className="h-3 w-32 bg-gray-200 rounded mb-1" />
          <div className="h-2 w-20 bg-gray-100 rounded" />
        </div>
      </div>

      <div className="h-6 w-12 bg-gray-200 rounded" />
    </div>
  ))
): productsModalItems.length === 0 ? (
          <div className="text-center text-sm text-gray-400 py-10">
            {lang === "AR" ? "لا يوجد منتجات" : "No products"}
          </div>
        ) : (
          productsModalItems.map((p) => (
            <div
  key={p.id}
  className="flex items-center justify-between gap-3 border border-gray-200 rounded-lg px-3 py-2"
>
              {/* LEFT */}
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 rounded-md overflow-hidden border bg-gray-50 flex items-center justify-center shrink-0">
                  {p.image ? (
                    <img
                      src={resolveImage(p.image)}
                      alt={p.name_en}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <div className="text-[10px] text-gray-400">
                      IMG
                    </div>
                  )}
                </div>

                <div className="min-w-0">
  <div className="text-[13px] font-medium text-gray-900 truncate leading-5">
    {p.name_en}
  </div>
  <div className="text-[11px] text-gray-500 truncate leading-4">
    {p.public_id}
  </div>
</div>
              </div>

              {/* RIGHT */}
              <div className="flex items-center gap-1.5 shrink-0">
  <button
    onClick={() => navigate(`/admin/products/edit/${p.id}`)}
    className="px-2.5 py-1 border rounded-md text-[11px] hover:bg-gray-50"
  >
    {lang === "AR" ? "فتح" : "Open"}
  </button>
</div>
            </div>
          ))
        )}

        {/* PAGINATION */}
{productsModalTotalPages > 1 && (
  <div className="pt-2 flex items-center justify-between border-t border-gray-100 mt-3 pt-3">
    <div className="text-[12px] text-gray-500">
      {lang === "AR"
        ? `صفحة ${productsModalPage} من ${productsModalTotalPages}`
        : `Page ${productsModalPage} of ${productsModalTotalPages}`}
    </div>

    <div className="flex items-center gap-2">
      <button
        onClick={() => fetchProductsModalPage(productsModal.id, productsModalPage - 1)}
        disabled={productsModalPage === 1 || productsModalLoading}
        className="px-3 py-1.5 border rounded-md text-[12px] hover:bg-gray-50 disabled:opacity-50"
      >
        {lang === "AR" ? "السابق" : "Previous"}
      </button>

      <button
        onClick={() => fetchProductsModalPage(productsModal.id, productsModalPage + 1)}
        disabled={productsModalPage === productsModalTotalPages || productsModalLoading}
        className="px-3 py-1.5 border rounded-md text-[12px] hover:bg-gray-50 disabled:opacity-50"
      >
        {lang === "AR" ? "التالي" : "Next"}
      </button>
    </div>
  </div>
)}
      </div>

      {/* FOOTER */}
      <div className="px-5 py-4 border-t bg-white rounded-b-2xl">
  <div className="flex justify-end">
        <button
          onClick={() => {
  closeProductsModal();
}}
          className="px-4 py-2 border rounded-md text-sm"
        >
          {lang === "AR" ? "إغلاق" : "Close"}
        </button>
      </div>
      </div>
    </div>
  </div>
)}

{showAddProductsModal && (
  <div
  className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4"
  onClick={() => setShowAddProductsModal(false)}
>
    <div
  className="
  w-full
  max-w-[640px]
  h-[60vh]
  md:h-auto
  bg-white
  rounded-t-2xl md:rounded-[18px]
  flex flex-col
  overflow-hidden
"
  onClick={(e) => e.stopPropagation()}
>
      {/* HEADER */}
      <div className="bg-[#f6f6f7] px-6 py-4 border-b flex items-center justify-between">
        <h3 className="text-[18px] font-semibold text-[#202223]">
          {lang === "AR" ? "إدارة المنتجات" : "Manage products"}
        </h3>

        <button
          onClick={() => setShowAddProductsModal(false)}
          className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-[#f1f2f3]"
        >
          ✕
        </button>
      </div>

      {/* SEARCH */}
      <div className="p-4 border-b">
        <div className="h-[42px] border border-[#8c9196] rounded-[12px] px-4 flex items-center gap-3">
          <FaSearch className="text-sm text-[#6d7175]" />
          <input
            value={productsSearch}
            onChange={(e) => {
              setProductsSearch(e.target.value);
              setProductsModalPage2(1);
            }}
            placeholder={lang === "AR" ? "بحث عن المنتجات..." : "Search products"}
            className="flex-1 outline-none text-sm"
          />
        </div>
      </div>

      {/* TABLE HEADER */}
      <div className="grid grid-cols-[40px_1fr] px-6 py-2 text-xs font-semibold text-[#6d7175] border-b bg-[#f6f6f7]">
        <div></div>
        <div>{lang === "AR" ? "المنتج" : "Product"}</div>
      </div>

      {/* LIST */}
      <div className="flex-1 overflow-y-auto">

  {loadingProductsList ? (
    [...Array(6)].map((_, i) => (
      <div
        key={i}
        className="grid grid-cols-[40px_1fr] items-center px-6 py-2 border-b animate-pulse"
      >
        <div className="w-4 h-4 bg-gray-200 rounded mx-auto" />

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gray-200 rounded" />
          <div>
            <div className="h-3 w-32 bg-gray-200 rounded mb-1" />
            <div className="h-2 w-20 bg-gray-100 rounded" />
          </div>
        </div>
      </div>
    ))
  ) : (
        paginatedProducts.map((p) => {

          const checked = !!selectedProductsMap[p.id];

          return (
            <div
  key={p.id}
  onClick={() => {
    setSelectedProductsMap((prev) => ({
      ...prev,
      [p.id]: !prev[p.id],
    }));
  }}
  className={`
    grid grid-cols-[40px_1fr] items-center px-6 py-2 border-b border-[#f1f2f3] transition cursor-pointer
    ${checked ? "bg-[#f6f6f7]" : "hover:bg-[#f6f6f7]"}
  `}
>

              {/* CHECKBOX */}
              <label className="flex items-center justify-center cursor-pointer">
  <input
    type="checkbox"
    checked={checked}
    onClick={(e) => e.stopPropagation()}
    onChange={() => {
      setSelectedProductsMap((prev) => ({
        ...prev,
        [p.id]: !prev[p.id],
      }));
    }}
    className="
      h-4 w-4
      rounded-[4px]
      border border-[#8c9196]
      text-[#202223]
      focus:ring-2 focus:ring-black/10
      accent-[#202223]
      cursor-pointer
    "
  />
</label>

              {/* PRODUCT */}
              <div className="flex items-center gap-3">

                <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border">
                  {p.image && (
                    <img src={p.image} className="w-full h-full object-cover" />
                  )}
                </div>

                <div>
                  <div className="text-sm font-semibold">
                    {p.name_en}
                  </div>
                  <div className="text-xs text-gray-500">
                    {p.public_id}
                  </div>
                </div>

              </div>

            </div>
          );
        })
)}
      </div>

      {/* PAGINATION */}
      <div className="px-6 py-4 border-t border-[#e1e3e5] flex items-center justify-between bg-[#f6f6f7]">
  <div className="text-[12px] text-[#6d7175]">
    {lang === "AR"
      ? `صفحة ${productsModalPage2} من ${Math.max(1, Math.ceil(filteredProductsModal.length / PRODUCTS_MODAL_LIMIT))}`
      : `Page ${productsModalPage2} of ${Math.max(1, Math.ceil(filteredProductsModal.length / PRODUCTS_MODAL_LIMIT))}`}
  </div>

  <div className="flex items-center gap-2">
    <button
      onClick={() => setProductsModalPage2((p) => Math.max(1, p - 1))}
      disabled={productsModalPage2 === 1}
      className="
        h-[32px] px-3
        rounded-[8px]
        border border-[#c9cccf]
        bg-white
        text-[#202223]
        text-xs font-medium
        hover:bg-[#f1f2f3]
        disabled:opacity-50 disabled:cursor-not-allowed
      "
    >
      {lang === "AR" ? "السابق" : "Previous"}
    </button>

    <button
      onClick={() =>
        setProductsModalPage2((p) =>
          p * PRODUCTS_MODAL_LIMIT < filteredProductsModal.length ? p + 1 : p
        )
      }
      disabled={productsModalPage2 >= Math.max(1, Math.ceil(filteredProductsModal.length / PRODUCTS_MODAL_LIMIT))}
      className="
        h-[32px] px-3
        rounded-[8px]
        border border-[#c9cccf]
        bg-white
        text-[#202223]
        text-xs font-medium
        hover:bg-[#f1f2f3]
        disabled:opacity-50 disabled:cursor-not-allowed
      "
    >
      {lang === "AR" ? "التالي" : "Next"}
    </button>
  </div>
</div>

      {/* FOOTER */}
<div className="
  px-6 py-4 border-t border-[#e1e3e5]
  flex justify-end gap-3
  bg-[#f6f6f7]
  sticky bottom-0
  rounded-b-2xl md:rounded-b-[18px]
">

  <button
    onClick={() => setShowAddProductsModal(false)}
    className="
      h-8 px-3
      border border-[#c9cccf]
      bg-white text-[#202223]
      rounded-lg text-sm font-medium
      hover:bg-[#f1f2f3]
      transition
    "
  >
    {lang === "AR" ? "إلغاء" : "Cancel"}
  </button>

  <button
    onClick={async () => {
      const selectedIds = Object.keys(selectedProductsMap)
        .filter((id) => selectedProductsMap[id])
        .map(Number);

      const existingIds = (productsModal.products || []).map((p) => p.id);

      const toAdd = selectedIds.filter((id) => !existingIds.includes(id));
      const toRemove = existingIds.filter((id) => !selectedProductsMap[id]);

      if (toAdd.length) {
        await addProductsToCategory(productsModal.id, toAdd);
      }

      if (toRemove.length) {
        await Promise.all(
          toRemove.map((id) =>
            removeAdminProductFromCategory(productsModal.id, id)
          )
        );
      }

      // 👉 1. update local modal products BEFORE reload (important)
const updatedProducts = allProducts.filter((p) =>
  selectedProductsMap[p.id]
);

setProductsModal((prev) =>
  prev
    ? {
        ...prev,
        products: updatedProducts,
        products_count: updatedProducts.length,
      }
    : prev
);

// 👉 2. reload categories (table)
await load();

// 👉 3. close everything
closeProductsModal();

// 👉 4. toast
setToastMessage(
  lang === "AR"
    ? "تم تحديث منتجات التصنيف"
    : "Collection products updated"
);
setShowToast(true);
setTimeout(() => setShowToast(false), 3000);

      setToastMessage(
        lang === "AR"
          ? "تم تحديث منتجات التصنيف"
          : "Collection products updated"
      );
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }}
    className="
      h-8 px-3
      bg-[#1f1f1f] text-white
      rounded-lg text-sm font-medium
      hover:bg-black
      flex items-center gap-2
      transition
    "
  >
    {lang === "AR" ? "حفظ" : "Save"}
  </button>

</div>

    </div>
  </div>
)}

      {/* TOAST */}
      {showToast && (
  <div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">
    <div className="
      flex items-center gap-3
      px-4 py-3
      bg-white
      border border-gray-200
      rounded-[12px]
      shadow-[0_10px_30px_rgba(0,0,0,0.12)]
    ">
      <div className="w-7 h-7 flex items-center justify-center rounded-full bg-green-100">
        <span className="text-green-700 text-sm">✓</span>
      </div>

      <div className="text-sm text-gray-800 font-medium">
        {toastMessage}
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default AdminCategories;